import { TableColumnsType } from "antd";
import dayjs from "dayjs";
import { useCallback, useMemo } from "react";
import { NavigateFunction } from "react-router-dom";
import { ProjectPartial } from "../../../../types/projects";
import StatusBadges from "../../StatusBadges";
import DropdownOptionsProject from "../components/DropdownOptionsProject/DropdownOptionsProject";

type Options = {
  navigate: NavigateFunction;
};

export default function useTableProjects({ navigate }: Options) {
  const columns = useMemo(() => {
    const _columns: TableColumnsType<ProjectPartial> = [
      {
        title: "TITRE",
        dataIndex: "name",
        key: "name",
        align: "left",
        width: 300,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "AUTEUR",
        dataIndex: ["creator", "fullname"],
        key: "author",
        align: "center",
        width: 200,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "DATE",
        dataIndex: "dateEvt",
        key: "dateEvt",
        align: "center",
        width: 100,
        render: (value) => dayjs(value).format("DD/MM/YYYY"),
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "LIEU",
        dataIndex: "localisation",
        key: "localisation",
        align: "center",
        width: 100,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "STATUT",
        dataIndex: "statut",
        key: "statut",
        align: "center",
        width: 100,
        render: (value) => <StatusBadges value={value} type="projects" />,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "",
        key: "options",
        dataIndex: "",
        align: "center",
        width: 10,
        render: (_, item) => (
          <DropdownOptionsProject
            itemId={item.id}
            goToDetails={(id) => navigate(`/projects/${id}`)}
            onModify={(id) => navigate(`/projects/${id}/edit`)}
          />
        ),
      },
    ];
    return _columns;
  }, [navigate]);

  const onRowClick = useCallback(
    (record: ProjectPartial) => ({
      onClick: () => navigate(`/projects/${record.id}`),
    }),
    [navigate],
  );

  return { columns, onRowClick };
}
